import React from 'react';
import classNames from 'classnames';
import { Button } from '@agissc/ktag-map';

interface RemoveButtonProps {
  label: string;
  onclick: () => void;
  noWrapper?: boolean;
}

const RemoveButton = ({ label, onclick, noWrapper = false }: RemoveButtonProps) => {
  return (
    <Button
      onClick={onclick}
      additionalClassNames={classNames('button__as-link', {
        'remove-button': !noWrapper,
      })}
    >
      {label}
    </Button>
  );
};

export default RemoveButton;
